import { useStore } from '@lib/state-engine';
import { ButtonClose } from '@ui/button';
import { Informer as CInformer } from '@consta/uikit/Informer';
import { $informers, deleteInformer } from './model';
import styles from './styles.module.css';

export const StatusInformer = () => {
  const informers = Object.values(useStore($informers));

  return (
    <div className={styles.container}>
      {informers.map(({ key, title, content, status }) => (
        <CInformer
          className={styles.informer}
          title={String(title)}
          status={status}
        >
          <ButtonClose className={styles.close} onClick={() => deleteInformer(key)} />
          {content}
        </CInformer>
      ))}
    </div>
  );
};
